import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

import AssetImage from "src/components/wizard/Item/AssetImage";

export default function AddItemQuantityModal({ asset, onConfirm, onBack, onClose, loading }) {
  const [quantity, setQuantity] = useState(1);

  const handleMinus = () => setQuantity(q => Math.max(1, q - 1));
  const handlePlus = () => setQuantity(q => Math.min(asset.availableQuantity, q + 1));
  const handleChange = e => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val) && val >= 1 && val <= asset.availableQuantity) {
      setQuantity(val);
    } else if (e.target.value === "") {
      setQuantity("");
    }
  };

  const handleConfirm = () => {
    const qty = parseInt(quantity, 10);
    if (qty >= 1 && qty <= asset.availableQuantity) {
      onConfirm(qty);
    }
  };

  const isValid = parseInt(quantity, 10) >= 1 && parseInt(quantity, 10) <= asset.availableQuantity;

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton onClick={onBack} size="small">
            <ArrowBackIcon />
          </IconButton>
          <Typography fontSize={22} fontWeight={500} color="textPrimary" flex={1} align="center">
            Select Quantity
          </Typography>
          <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" gap={2} mb={3}>
          <AssetImage width={80} height={70} image={asset?.images?.[0]?.url} />
          <Box flex={1}>
            <Typography variant="body1" fontWeight={600}>
              {asset.itemId}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {asset.description}
            </Typography>
            <Typography variant="body2" mt={0.5}>
              Available: {asset.availableQuantity}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
          <IconButton
            onClick={handleMinus}
            disabled={quantity <= 1}
            sx={{ border: "1px solid", borderColor: "divider" }}
          >
            <RemoveIcon />
          </IconButton>
          <TextField
            value={quantity}
            onChange={handleChange}
            inputProps={{ min: 1, max: asset.availableQuantity, style: { textAlign: "center" } }}
            sx={{ width: 80 }}
            size="small"
          />
          <IconButton
            onClick={handlePlus}
            disabled={quantity >= asset.availableQuantity}
            sx={{ border: "1px solid", borderColor: "divider" }}
          >
            <AddIcon />
          </IconButton>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onBack} disabled={loading}>
          Back
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!isValid || loading}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Add to Order
        </Button>
      </DialogActions>
    </Dialog>
  );
}
